var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "growth 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_206_4180",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipPath5156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5154",
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_206_4180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5160",
    d: "M17.3841 10.3659C17.5406 10.883 17.625 11.4319 17.625 12C17.625 13.5534 16.9955 14.9597 15.9773 15.9773C14.9596 16.9955 13.5534 17.625 12 17.625C10.4466 17.625 9.04031 16.9955 8.02266 15.9773C7.37719 15.3319 6.88781 14.5304 6.61589 13.6341C6.45933 13.117 6.375 12.5681 6.375 12C6.375 8.89364 8.89359 6.375 12 6.375C14.5383 6.375 16.6838 8.05641 17.3841 10.3659Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5158_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5160_2",
    d: "M20.9783 9.28157C21.2393 10.1433 21.3799 11.0581 21.3799 12.005C21.3799 14.5941 20.3307 16.9378 18.6337 18.6339C16.9376 20.3309 14.5939 21.38 12.0049 21.38C9.41582 21.38 7.07207 20.3309 5.37598 18.6339C4.30019 17.5581 3.48457 16.2223 3.03137 14.7285C2.77043 13.8667 2.62988 12.9519 2.62988 12.005C2.62988 6.82774 6.82754 2.63 12.0049 2.63C16.2354 2.63 19.8111 5.43235 20.9783 9.28157Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5164",
    d: "M9.46219 10.7878C9.2925 10.6181 9.1875 10.3838 9.1875 10.125C9.1875 9.60708 9.60703 9.1875 10.125 9.1875C10.6429 9.1875 11.0625 9.60708 11.0625 10.125C11.0625 10.3838 10.9575 10.6181 10.7878 10.7878C10.6181 10.9575 10.3837 11.0625 10.125 11.0625C9.86625 11.0625 9.63187 10.9575 9.46219 10.7878Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5168",
    d: "M14.5378 13.2122C14.7075 13.3819 14.8125 13.6163 14.8125 13.875C14.8125 14.3929 14.393 14.8125 13.875 14.8125C13.3571 14.8125 12.9375 14.3929 12.9375 13.875C12.9375 13.6163 13.0425 13.3819 13.2122 13.2122C13.3819 13.0425 13.6163 12.9375 13.875 12.9375C14.1337 12.9375 14.3681 13.0425 14.5378 13.2122Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5172",
    d: "M23.5312 5.15625C23.5312 5.67422 23.1117 6.09375 22.5937 6.09375C22.335 6.09375 22.1006 5.98875 21.9309 5.81906C21.7613 5.64938 21.6562 5.415 21.6562 5.15625C21.6562 4.63828 22.0758 4.21875 22.5937 4.21875C23.1117 4.21875 23.5312 4.63828 23.5312 5.15625Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5176",
    d: "M2.34375 18.8438C2.34375 19.3617 1.92422 19.7812 1.40625 19.7812C0.888281 19.7812 0.46875 19.3617 0.46875 18.8438C0.46875 18.3258 0.888281 17.9063 1.40625 17.9063C1.665 17.9063 1.89937 18.0113 2.06906 18.1809C2.23875 18.3506 2.34375 18.585 2.34375 18.8438Z",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5180",
    d: "M2.06934 18.1809L9.46251 10.7877",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5184",
    d: "M10.7881 10.7879L13.2125 13.2123",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5188",
    d: "M14.5381 13.2122L21.9313 5.81899",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5192",
    d: "M12 2.625V6.375",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5196",
    d: "M6.375 12H2.625",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5200",
    d: "M5.37109 18.629L8.02281 15.9773",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5204",
    d: "M18.6293 18.629L15.9775 15.9773",
    stroke: "#202842",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5208",
    d: "M5.8125 5.34375C5.8125 5.60259 5.60259 5.8125 5.34375 5.8125C5.08491 5.8125 4.875 5.60259 4.875 5.34375C4.875 5.08491 5.08491 4.875 5.34375 4.875C5.60259 4.875 5.8125 5.08491 5.8125 5.34375Z",
    fill: "#202842"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStr);
export default __webpack_public_path__ + "static/media/str.52641f663a37cabf7a3a49c268198de0.svg";
export { ForwardRef as ReactComponent };